// @core/api/endpoints/document/list_audit_log.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditLogResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List audit log
 * Returns the complete document audit trail for any document-aware entity.
 */
export async function ListAuditLog(
  target_type: string,
  target_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditLogResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/audit-log`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListAuditLogResponse>(requestPath, { ...requestOptions, params });
}
